import React , {useState, useEffect }from "react";
import { useSelector } from 'react-redux';
import { logout } from "../features/user/userSlice";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {IMAGE_URL} from "../utils/constants";

export default function Header() {
    const User = useSelector((state) => state.user.user);
    const [UserDetail, setUserDetail] = useState({})
    const dispatch = useDispatch();
    const [is_pro_dropdown, setDropdown] = useState(false)

    useEffect(()=>{
        if (User?.user_details){
            setUserDetail(User?.user_details)
        }
    })

    const handleLogout = () => {
        dispatch(logout()); 
    };

    const handlePorofileDrop = () => {
        setDropdown((prev) => !prev);
    }

  return (
   <>
      <header>
          <div className="container">
            <div className="row justify-content-between align-items-center">
              <div className="col-12">
                <div className="header-menu">
                  <ul className="header-menu-list">
                    {/* <li className="nav-item">
                      <a href="/notification" className="header-link-btn">
                        <img
                          src="/assets/images/notification-icon.svg"
                          alt="Notifications"
                        />
                      </a>
                    </li> */}
                    <li className="nav-item">
                      <div className="profile-nav-wrapper position-relative">
                        <button className="header-link-btn profile_btn" id="profilenavBtn" onClick={handlePorofileDrop}>
                          <img src={IMAGE_URL+"user.png"} alt="User" />
                          <svg
                            width="12"
                            height="8"
                            viewBox="0 0 12 8"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1 1.5L6 6.5L11 1.5"
                              stroke="#707070"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </button>
                           <div className={is_pro_dropdown ? "profile-list-dropdown" : "d-none"}> 
                                <ul className="list-unstyled mb-0">
                                    <li>
                                        <div
                                            className="profile-list-preview">
                                            <span
                                                className="profile-img">
                                                <img
                                                    src={IMAGE_URL+"user.png"}
                                                    alt="Profile" />
                                            </span>
                                            <span
                                                className="profile-detail">
                                                <span
                                                    className="profile-name capitalize">{UserDetail.first_name} {UserDetail.last_name}</span>
                                                <span
                                                    className="profile-email">{UserDetail.email}</span>
                                            </span>
                                        </div>
                                    </li>
                                    <li>
                                        <Link to="/profile"
                                            className="profile-links-list"><span
                                                className="navicon"><i
                                                    className="fa-regular fa-user"></i></span>Profile
                                            Detail</Link>
                                    </li>
                                    <li>
                                        <a onClick={handleLogout} 
                                            className="profile-links-list"><span
                                                className="navicon"><i
                                                    className="fa-solid fa-arrow-right-from-bracket"></i></span>Logout</a>
                                    </li>
                                </ul>
                            </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </header>

   </>
  );
}
